import React from 'react';
import ViewGeneralSettingComponent from '../../../Components/GeneralSetting/ViewGeneralSetting';

export default function ViewGeneralSetting() {
    return (
        <div className='page-body'>
            <ViewGeneralSettingComponent />
        </div>
    );
}